import { addMonths, subDays } from "date-fns";

/*
 * Why do we need utils to display an end date ?
 * Because Reviews objects are written as *periods* in our database, but we want a clearer way to display it to users.
 *
 * Let's say we have two 12-months campaigns following each other:
 * Review #0 will be on the period
 * - [01/01/1999 00:00:000 ... 01/01/2000 00:00:000[
 * And review #1 on
 * - [01/01/2000 00:00:000 ... 01/01/2001 00:00:000[

 * So when calling our APIs, they send back to us
 * [
 *     0: {"period_start: 01/01/1999", "period_end: 01/01/2000"},
 *     1: {"period_start: 01/01/2000", "period_end: 01/01/2001"},
 * ]
 *
 * BUT it was confusing for users to have "01/01/2000" be both the end date of review #0 *and* the start date of review #1
 * Therefore we prefer to display the end date of review #0 as "31/12/1999"
 *
 */
export function formatEndDate(endDate: Date) {
  return subDays(endDate, 1);
}

/*
 * With that logic, a new campaign ought to start the last day of the previous campaign
 * We made a utils despite this being a 1-liner so we can regroup all date-related shenanigans and test them
 */
export function calculateNextCampaignStartDate(
  previousCampaignEndDate: string | Date
) {
  return new Date(previousCampaignEndDate);
}

export function calculateNextCampaignEndDate(
  startDate: Date,
  duration?: number
) {
  return addMonths(startDate, duration ?? 12);
}
